import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputSelectStringInterface } from "../../../interfaces/Global.interface";

export default function FormularyHeaderInputSelectString({
	columnName,
	inputPlaceholder,
	formAction,
	value,
	onChangeFormValue,
	variableName,
	itemId,
	values,
	onClickCellName = () => {},
	enabledCellClick = false,
	enabledFilter = false,
	filterValue = "",
	setFilterValue = () => {},
	refreshTable = () => {},
}: FormularyHeaderInputSelectStringInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column, ColumnGroup } = Table;
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<ColumnGroup title={columnName}>
			<Column
				className='generalStyles__hoverCursor'
				onCell={(record: any) => ({
					onClick: () => {
						if (enabledCellClick && formAction === "create") {
							onClickCellName(record);
						}
					},
				})}
				filterDropdown={() => (
					<>
						{enabledFilter && (
							<FilterSearchText
								placeHolder={inputPlaceholder}
								filterValue={filterValue}
								setFilterValue={setFilterValue}
								refreshTable={refreshTable}
								refreshRequireParamenters
							/>
						)}
					</>
				)}
				filterIcon={enabledFilter ? undefined : () => null}
				title={
					<Select
						optionFilterProp='children'
						allowClear={false}
						size='small'
						value={formAction === "create" ? value : ""}
						disabled={formAction === "edit"}
						className='generalStyles__width100'
						placeholder={inputPlaceholder}
						onChange={(e: string) => {
							onChangeFormValue(e, variableName);
						}}
					>
						{values.map((item: string) => (
							<Option key={item} value={item}>
								{item}
							</Option>
						))}
					</Select>
				}
				dataIndex={variableName}
				key={variableName}
				render={(text, record: any) => (
					<div>
						{formAction === "edit" && record.id === itemId ? (
							<Select
								optionFilterProp='children'
								allowClear={false}
								size='small'
								value={value}
								className='generalStyles__width100'
								placeholder={inputPlaceholder}
								onChange={(e: string) => {
									onChangeFormValue(e, variableName);
								}}
							>
								{values.map((item: string) => (
									<Option key={item} value={item}>
										{item}
									</Option>
								))}
							</Select>
						) : (
							<div>{text}</div>
						)}
					</div>
				)}
			/>
		</ColumnGroup>
	);
}
